import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import React, { useContext, useRef } from 'react'
import * as ReactIcons from 'react-icons/tb'
import Slider, { Settings } from 'react-slick'

import colorContext from '../../../../Context/colorContext'
import { ChannelAttendances } from '../../types/get.channelAttendances'
import stylesChannelAttendante from './stylesChannelAttendante'

interface Props {
  channelList: ChannelAttendances[]
}

export default function ChannelAttendante({ channelList }: Props): JSX.Element {
  const { colors } = useContext(colorContext)
  const sliderRef = useRef<Slider | null>(null)

  const matchesMobile = useMediaQuery('(max-width:660px)')
  const matchesTablet = useMediaQuery('(max-width:1250px)')
  const classes = stylesChannelAttendante({
    colors,
    matches: matchesTablet,
    matchesMobile,
  })

  const settings: Settings = {
    speed: 500,
    infinite: true,
    arrows: true,
    slidesToShow: matchesMobile
      ? 2
      : channelList.length >= 6
      ? 6
      : channelList.length,
    slidesToScroll: 1,
    rows: matchesMobile ? 2 : 1,
    slidesPerRow: 1,
    nextArrow: <></>,
    prevArrow: <></>,
    responsive: [
      {
        breakpoint: 321,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
    ],
  }

  const controller = (
    <Box
      display="flex"
      alignItems="center"
      flexDirection={matchesTablet ? 'column' : 'row'}
      style={{ gap: 24 }}
    >
      <Box display="flex" alignItems="center" style={{ gap: 8 }}>
        <IconButton
          className={classes.iconNavite}
          color="primary"
          onClick={() => sliderRef.current.slickPrev()}
        >
          <NavigateBeforeIcon className={classes.iconNavigate} />
        </IconButton>
        <IconButton
          className={classes.iconNavite}
          color="primary"
          onClick={() => sliderRef.current.slickNext()}
        >
          <NavigateNextIcon className={classes.iconNavigate} />
        </IconButton>
      </Box>
    </Box>
  )

  return (
    <Box className={classes.main}>
      <Typography variant="h3" className={classes.title}>
        Canais de contato
      </Typography>

      <Box className={classes.sliderContainer}>
        <Slider {...settings} ref={sliderRef} className={classes.slider}>
          {channelList.map((channel, index) => (
            <Box
              key={`${channel.icone}-${index}`}
              className={
                matchesMobile
                  ? classes.iconContainerPhone
                  : classes.iconContainer
              }
              onClick={() => window.open(channel.url, '_blank')}
            >
              <Box
                className={classes.icon}
                sx={{ padding: `${matchesTablet ? '1rem' : '1.8rem'}` }}
              >
                {ReactIcons[channel.icone] ? (
                  React.createElement(ReactIcons[channel.icone], {
                    fontSize: matchesMobile ? 80 : '60px',
                    color: '#fff',
                  })
                ) : (
                  <span
                    style={{
                      fontSize: matchesMobile ? 70 : 80,
                      color: '#fff',
                    }}
                  >
                    {channel.icone}
                  </span>
                )}
              </Box>

              <Typography variant="h4" className={classes.titleChannel}>
                {channel.titulo}
              </Typography>
            </Box>
          ))}
        </Slider>
      </Box>

      {!matchesMobile && channelList.length > 6 ? (
        <>{controller}</>
      ) : (
        channelList.length > 4 && <>{controller}</>
      )}
    </Box>
  )
}
